class Utility {
  expandCareers(careers) {
    careers =  careers[0].jobLists;
    let careerslist = JSON.parse(JSON.stringify(careers));

    careerslist.forEach(function (career) {
      if ( career.hasOwnProperty('altTitles') ) {

        Object.keys(career.altTitles).forEach(function (alt) {

          let altCareer = JSON.parse(JSON.stringify(career));
          altCareer.cascaidId = career.altTitles[alt].altTitle;
          altCareer.career = career.altTitles[alt].altTitle;
          altCareer.altTitles = {};
          altCareer.id = career.altTitles[alt].altTitle


          careers.push(altCareer);
        }, this);
      }
    }, this);
    return careers;
  }

  dynamics(data) {
    if (data.dynamics) {
      if (!data.slugTrans) {
        data.slugTrans = data.slug;
      }

      data.dynamics.forEach(function (element) {

        if (!element['section']) {
          element['section'] = [];
        }
        // Not nice.
        if (element['dynamicCode'].toLowerCase() === 'd36') {
          element['section'].forEach(function (section, index) {
            if (section['type'] === 'list') {
              element['section'][index]['type'] = 'double_list';
            }
          }, this);
        }

        data[element['dynamicCode'].toLowerCase()] = element['section'];
      }, this);
    }
    return data;
  }

}

export default (new Utility());
